module.exports = __webpack_public_path__ + "img/Optimise.cf2c1372.png";